module.exports = ".chart-container {\n  height: 100%;\n  min-height: 300px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/widgets/piechart/piechart.component.scss
// module id = ./src/app/shared/components/widgets/piechart/piechart.component.scss
// module chunks = main